import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-standard-confirm',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule
  ],
  templateUrl: './standard-confirm.component.html',
  styleUrl: './standard-confirm.component.scss'
})
export class StandardConfirmComponent {
  ref = inject(DynamicDialogRef);
  cfg = inject(DynamicDialogConfig);
  close(ok: boolean) { this.ref.close(ok); }
}
